module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/axios/index.js
// module id = 7
// module chunks = 3